/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlanDto } from '../../models/plan-dto';

export interface ApiBillingPlansCodeGet$Params {
  code: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiBillingPlansCodeGet(http: HttpClient, rootUrl: string, params: ApiBillingPlansCodeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanDto>> {
  const rb = new RequestBuilder(rootUrl, apiBillingPlansCodeGet.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlanDto>;
    })
  );
}

apiBillingPlansCodeGet.PATH = '/api/Billing/plans/{code}';
